import { render, staticRenderFns } from "./ConsoleWarnings.vue?vue&type=template&id=2af33399&scoped=true"
import script from "./ConsoleWarnings.vue?vue&type=script&lang=js"
export * from "./ConsoleWarnings.vue?vue&type=script&lang=js"
import style0 from "./ConsoleWarnings.vue?vue&type=style&index=0&id=2af33399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af33399",
  null
  
)

export default component.exports